// Fictional watch shown wherever the passport card appears as a preview
// (pricing page, landing final CTA).
//
// It borrows no real maison and names no one: a preview must not lean on a
// brand's identity, and the holder line is simply left out rather than
// inventing a person (PassportCard renders it only when present).
//
// Descriptive values go through `t` so the preview stays bilingual. The
// provena_id stays literal — the card's QR resolves against it.
export const buildSamplePassport = (t) => ({
  provena_id: "PRV-000128",
  brand: t("demoPassport.maker"),
  model: t("demoPassport.model"),
  year: "2019",
});

export default buildSamplePassport;
